export const background = "#fbfcfffa"
export const dark = "#1e1e1e"
export const light = "#eee"
export const accentMain = "#2776ba"
export const accentMainLight = "#ffe4e2"
export const accentSecondary = "#f27474"
export const accentSecondaryLight = "#daf3ff"
export const blackTransparent = "rgba(150,150,150, 0.8)"

export const mainFont = "'Quicksand', sans-serif"
export const headerFont = "'PT Sans', sans-serif"

export const shadowMain = "2px 5px 10px #ddd"
export const borderRadius = "5px"
